import { Helmet } from 'react-helmet-async';
import { PublicNavbar } from '@/components/layout/PublicNavbar';
import { PublicFooter } from '@/components/layout/PublicFooter';

export default function Blog() {
  return (
    <div className="min-h-screen bg-white dark:bg-white transition-colors duration-300 text-ink transition-colors duration-300">
      <Helmet>
        <title>Blog | Monkey Barber Club</title>
      </Helmet>
      <PublicNavbar />
      <section className="pt-32 pb-20 from-surface-2 via-black to-surface-2">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-6xl md:text-7xl font-black mb-6">
              <span className="from-surface-2 via-surface-2 to-surface-2 bg-clip-text text-transparent">BLOG</span>
            </h1>
          </div>
        </div>
      </section>
      <section className="py-20 bg-surface-3">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8">
            <div className="bg-surface-3 rounded-xl p-6 border border-hairline">
              <div className="text-6xl mb-4">✂️</div>
              <h2 className="text-2xl font-bold mb-3">Guia del Fade</h2>
              <p className="text-ink-subtle">Todo sobre los diferentes tipos de fade</p>
            </div>
            <div className="bg-surface-3 rounded-xl p-6 border border-hairline">
              <div className="text-6xl mb-4">🧔</div>
              <h2 className="text-2xl font-bold mb-3">Cuidados de Barba</h2>
              <p className="text-ink-subtle">Rutina profesional para tu barba</p>
            </div>
            <div className="bg-surface-3 rounded-xl p-6 border border-hairline">
              <div className="text-6xl mb-4">🔥</div>
              <h2 className="text-2xl font-bold mb-3">Tendencias 2025</h2>
              <p className="text-ink-subtle">Los cortes mas solicitados</p>
            </div>
          </div>
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
